/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![StampIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA/klEQVR4nOWTMUoDYRCF/yqnEItACs+ymZmXhWVmY5ki10gZzSkERQtPYUgXvIOFUYQkTbBd2crFPxt1dySFD171w/uGN/OH8C/U72enJHbL0FcWeyHYzWBwfuISDugZQbcMK6omsXWS5r3WAIbefw2vQK49AJs6QFlXe4DYWy0A9tQaQLC72opgV60BSZr3SOw9BuguSYfd4CGRfBwvWEfBUwR9/KxGl8FbDJtVzvPSHUCik0o9k18HZFnWYegFia4OnGVxyAR9Zti0zIoA5UPTYI493VdB48n5Jz/ccfqidAwQnXuFE+whHE0EWzTvXuffAty799wFHbX7v9IH4bOdYKr0fvAAAAAASUVORK5CYII=)
 */
export const StampIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M13.5 11.73c0-1.22.84-2.26 1.6-3.21a4 4 0 1 0-6.22 0c.78.95 1.62 1.99 1.62 3.21V13H5a3 3 0 0 0-3 3v1a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-1a3 3 0 0 0-3-3h-5.5v-1.27ZM5 19a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H5Z"
        className={colorClass}
      />
    </svg>
  );
};
